import { keyframes } from 'styled-components';

// https://zeroheight.com/3fe730a39/v/0/p/903499-motion
export const easing = {
  standard: 'cubic-bezier(0.3, 0.75, 0.34, 0.95)',
  entrance: 'cubic-bezier(0, 0, 0.34, 0.95)',
  exit: 'cubic-bezier(0.3, 0.75, 1, 0.95)',
  primary: 'cubic-bezier(0.4, 0, 0, 1)',
};

export const duration = {
  quick: '60ms',
  short: '120ms',
  medium: '200ms',
  long: '300ms',
  slideover: '400ms',
  dramatic: '600ms',
};

export const fadeIn = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;

export const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const slideUpFade = keyframes`
from {
  opacity: 0;
  transform: translateY(2px);
}
to {
  opacity: 1;
  transform: translateY(0);
}
`;

export const slideDownFade = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(2px);
  }
`;

export const slideRightFade = keyframes`
from {
  opacity: 0;
  transform: translateX(-4px);
}
to {
  opacity: 1;
  transform: translateX(0px);
}
`;

export const slideFromRight = keyframes`
    from {
        transform: translateX(100%);
    }
    to {
        transform: translateX(0px);
    }
`;
